/* eslint-disable jsx-a11y/anchor-is-valid */
import  {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'


import SearchShowCustomer from '../../modules/searchShowCustomer/CustomerPage'
import UpdateCustomerPage from '../../modules/updateCustomer/UpdateCustomerPage'



const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
        <SearchShowCustomer></SearchShowCustomer>
      <div className='col-xxl-12' style={{marginTop:0}}>
        <UpdateCustomerPage></UpdateCustomerPage>
      </div>
    </div>
    {/* end::Row */}
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{"Ana Sayfa"}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
